var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicPhoneCodemin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 161,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    className: "animate-subtle-move"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.886 50.891c-.194 0-.386.01-.579.015l.001-.015c0-17.06-13.865-30.891-30.967-30.891-13.889 0-25.641 9.12-29.568 21.684a21.272 21.272 0 0 0-9.922-2.443c-11.78 0-21.329 9.526-21.329 21.276 0 1.915.258 3.768.733 5.533a17.216 17.216 0 0 0-6.995-1.486c-9.532 0-17.26 7.709-17.26 17.218C32 91.292 39.728 99 49.26 99h98.626C161.204 99 172 88.23 172 74.945s-10.796-24.054-24.114-24.054Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    className: "animate-subtle-move animation-delay-500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.018 98.724c.129 0 .257.007.385.01v-.01c0-11.445 9.21-20.724 20.571-20.724 9.225 0 17.032 6.119 19.641 14.548a14.018 14.018 0 0 1 6.591-1.64c7.825 0 14.169 6.391 14.169 14.275 0 1.284-.171 2.527-.487 3.711a11.341 11.341 0 0 1 4.646-.997c6.333 0 11.466 5.172 11.466 11.552 0 6.379-5.133 11.551-11.466 11.551h-65.516c-8.846 0-16.018-7.225-16.018-16.138 0-8.913 7.172-16.138 16.018-16.138Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.424 43.86h49.408c3.84 0 7.168 3.072 7.168 7.168v89.856c0 3.84-3.072 7.168-7.168 7.168h-49.664c-3.84 0-7.168-3.072-7.168-7.168V51.028c.256-3.84 3.328-7.168 7.424-7.168Z",
    fill: "#DABDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.64 51.028h44.8c.512 0 1.28.255 1.792.767s.768 1.024.768 1.792v82.688c0 .512-.256 1.28-.768 1.792s-1.024.768-1.792.768h-44.8a2.294 2.294 0 0 1-2.304-2.304v-83.2c0-.512.256-1.28.768-1.792.256-.256.768-.511 1.536-.511ZM122.064 144.467h6.656c.768 0 1.28-.512 1.28-1.28s-.512-1.28-1.28-1.28h-6.656c-.768 0-1.28.512-1.28 1.28s.512 1.28 1.28 1.28Z",
    fill: "#0190ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.248 134.168a3.584 3.584 0 1 1 .001-7.169 3.584 3.584 0 0 1-.001 7.169ZM136.416 134.168a3.584 3.584 0 1 1 .001-7.169 3.584 3.584 0 0 1-.001 7.169ZM118.08 134.168a3.584 3.584 0 1 1 .001-7.169 3.584 3.584 0 0 1-.001 7.169Z",
    fill: "#DABDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m113.601 97.114.863 3.741h-3.67l.864-3.74-2.869 2.606-1.789-3.19 3.671-1.103L107 94.263l1.882-3.128 2.776 2.606-.864-3.741h3.67l-.894 3.803 2.899-2.668 1.82 3.189-3.794 1.135 3.794 1.134-1.881 3.128-2.807-2.607Z",
    fill: "#fff",
    className: "animate-fade-out-in opacity-20 animation-delay-1200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m142.179 97.114.863 3.741h-3.67l.864-3.74-2.869 2.606-1.789-3.19 3.671-1.103-3.671-1.165 1.882-3.128 2.776 2.606-.864-3.741h3.67l-.894 3.803 2.899-2.668 1.82 3.189-3.794 1.135 3.794 1.134-1.881 3.128-2.807-2.607Z",
    fill: "#fff",
    className: "animate-fade-out-in opacity-20 animation-delay-1000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m127.89 97.114.863 3.741h-3.67l.864-3.74-2.869 2.606-1.789-3.19 3.671-1.103-3.671-1.165 1.882-3.128 2.776 2.606-.864-3.741h3.67l-.894 3.803 2.899-2.668 1.82 3.189-3.794 1.135 3.794 1.134-1.881 3.128-2.807-2.607Z",
    fill: "#fff",
    className: "animate-fade-out-in opacity-20 animation-delay-700"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 64.5,
    r: 30.5,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animate-spin-xl",
    style: {
      transformOrigin: "11rem 4rem"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192.998 59.64a.961.961 0 0 0-.961-.96h-26.893a.961.961 0 0 0-.96.96v1.921h28.814v-1.92Z",
    fill: "#FF4AA2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164.184 79.948a.96.96 0 0 0 .96.96h26.893a.962.962 0 0 0 .961-.96v-1.921h-28.814v1.921Z",
    fill: "#E31587"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.185 61.484H193v7.96h-28.815v-7.96Zm0 7.961H193v8.488h-28.815v-8.488Z",
    fill: "#FF4AA2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.769 68.783a2.79 2.79 0 1 0-2.444 0l-1.508 3.187a.661.661 0 0 0 .593.93h4.278a.656.656 0 0 0 .593-.93l-1.512-3.187Z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.628 54.46a6.003 6.003 0 1 1 12.007 0v1.259h-.001V58.6h4.802v-2.88h.001v-1.26a10.806 10.806 0 0 0-21.612 0v4.14h4.803v-4.141Z",
    fill: "#FF4AA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: -14,
    width: 204,
    height: 143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5446_43042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5446_43042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 95,
    y: 44,
    width: 157,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5446_43042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5446_43042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 116,
    y: 4,
    width: 125,
    height: 125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5446_43042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5446_43042",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicPhoneCodemin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_phone_code.min.9501b9d3c7a03bdd61b91440dbe25ccd.svg";